import styled from 'styled-components/macro';
import { media, space } from '../../../theme/tokens';
import { SpaceBetweenLink } from '../../common/elements/Students';

// a task in the list: on phones the status sits under the card so every card is
// full width; from tablet up it sits beside the card
export const TaskRowLink = styled(SpaceBetweenLink)`
  flex-direction: column;
  align-items: stretch;
  gap: ${space[2]};

  & > :last-child {
    align-self: flex-end;
  }

  ${media.sm`
    flex-direction: row;
    align-items: center;
    gap: ${space[3]};

    & > :last-child {
      align-self: center;
    }
  `}
`;

export * from '../../common/elements/Notifications';
export * from '../../common/elements/Students';
